// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TIgMm","field":"styles_field__1tqTn","fieldCol":"styles_fieldCol__1gbjR","diffCol":"styles_diffCol__1XJYe","diff":"styles_diff__1iyv8"};